<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" :size="'448px'" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <el-form
						ref="form"
						class="mobile-ruleForm card-ruleForm"
						label-width="114px"
						label-position="left"
					>
            <el-form-item
              class="el-form-item-update"
              ref="staffName"
              label="月份"
              prop="staffName"
            >
              <el-date-picker
                v-model="form.month"
                type="month"
                :clearable="false"
                value-format="yyyy-MM"
                placeholder="选择月"
                @change="getExceptions"
                class="w200"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              class="el-form-item-update"
              ref="leaveCateId"
              label="店员姓名"
              prop="leaveCateId"
            >
              <el-select v-model="form.staffId" placeholder="请选择" @change="getExceptions" class="w200" v-if="isSuperManage">
                <el-option
                  v-for="item in staffList"
                  :key="item.id"
                  :label="item.staffName"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-input v-model="form.staffName" disabled v-else class="w200"></el-input>
            </el-form-item>
					</el-form>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>打卡异常（{{total}}次）</i></p>
          <div class="plr24" v-if="total > 0">
            <div class="list-box">
              <div class="list-item cur" @click="showItem('late')">
                <div>迟到：{{dataList.overtimeTotal}}次</div>
                <div v-if="dataList.overtimeTotal > 0"><i class="el-icon-arrow-down"></i></div>
              </div>
              <div class="ml10 mr10" v-if="isGetDataFlag == 'late'">
                <div class="align-items attendanceBox" v-for="(item,index) in list1" :key="index">
                  <div>{{formatDay(item.attendanceDate)}}&nbsp;({{item.attendanceTypeCn}})</div>
                <template>
                  <div class="jishi cur" @click="goDealWith(item)" v-if="item.showGoProcessFlag">去处理</div>
                  <div class="jishi cur" v-else-if="item.showWaitAuditFlag">待审核</div>
                  <div class="jishi cur" v-else >已处理</div>
                </template>
                </div>
              </div>
            </div>
            <div class="list-box">
              <div class="list-item cur" @click="showItem('loss')">
                <div>缺卡：{{dataList.absenceTotal}}次</div>
                <div v-if="dataList.absenceTotal > 0"><i class="el-icon-arrow-down"></i></div>
              </div>
              <div class="ml10 mr10" v-if="isGetDataFlag == 'loss'">
                <div class="align-items attendanceBox" v-for="(item,index) in list2" :key="index">
                  <div>{{formatDay(item.attendanceDate)}}&nbsp;({{item.attendanceTypeCn}})</div>
                  <template>
                    <div class="jishi cur" @click="goDealWith(item)" v-if="item.showGoProcessFlag">去处理</div>
                    <div class="jishi cur" v-else-if="item.showWaitAuditFlag">待审核</div>
                    <div class="jishi cur" v-else >已处理</div>
                  </template>
                </div>
              </div>
            </div>
            <div class="list-box">
              <div class="list-item cur" @click="showItem('no')">
                <div>旷工：{{dataList.noAttendanceTotal}}天</div>
                <div v-if="dataList.noAttendanceTotal > 0"><i class="el-icon-arrow-down"></i></div>
              </div>
              <div class="ml10 mr10" v-if="isGetDataFlag == 'no'">
                <div class="align-items attendanceBox" v-for="(item,index) in list3" :key="index">
                  <div>{{formatDay(item.attendanceDate)}}&nbsp;({{item.attendanceTypeCn}})</div>
                  <template>
                    <div class="jishi cur" @click="goDealWith(item)" v-if="item.showGoProcessFlag">去处理</div>
                    <div class="jishi cur" v-else-if="item.showWaitAuditFlag">待审核</div>
                    <div class="jishi cur" v-else >已处理</div>
                  </template>
                </div>
              </div>
            </div>
            <div class="list-box">
              <div class="list-item cur" @click="showItem('leaveEarly')">
                <div>早退：{{dataList.leaveEarlyTotal}}次</div>
                <div v-if="dataList.leaveEarlyTotal > 0"><i class="el-icon-arrow-down"></i></div>
              </div>
              <div class="ml10 mr10" v-if="isGetDataFlag == 'leaveEarly'">
                <div class="align-items attendanceBox" v-for="(item,index) in list4" :key="index">
                  <div>{{formatDay(item.attendanceDate)}}&nbsp;({{item.attendanceTypeCn}})</div>
                  <template>
                    <div class="jishi cur" @click="goDealWith(item)" v-if="item.showGoProcessFlag">去处理</div>
                    <div class="jishi cur" v-else-if="item.showWaitAuditFlag">待审核</div>
                    <div class="jishi cur" v-else >已处理</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </drawer>
    <el-dialog title="异常处理" :visible.sync="dialogVisible" width="600px" :before-close="cancel">
      <div class="iscompanyQuit" style="margin: 0 0 10px 0;">
        <img
          src="../../../assets/images/new/blueInfo.png"
          alt=""
        />{{ description }}
      </div>
      <el-row class="elRow">
        <el-col :span="12">
          <span>店员姓名：</span>
          <span>{{parmar.staffName}}</span>
        </el-col>
        <el-col :span="12">
          <span>异常类型：</span>
          <span>{{parmar.abnormalAttendanceTypeCn}}</span>
        </el-col>
        <el-col :span="12" class="mt20">
          <span>打卡时间：</span>
          <span>{{formatDay(parmar.attendanceDate)}}</span>
        </el-col>
        <el-col :span="12" class="mt20">
          <span>打卡类型：</span>
          <span>{{parmar.attendanceTypeCn}}</span>
        </el-col>
        <el-col :span="12" class="mt20">
          <span>打卡状态：</span>
          <span>
            <el-select v-model="parmar.punchStatus" placeholder="请选择" class="w100" @change="skip">
              <el-option v-for="item in option2" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </span>
        </el-col>
      </el-row>
      <div class="dialog-remark">备注</div>
      <el-input v-model="parmar.remark" placeholder="请输备注" type="textarea" maxlength="150"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: {
    drawer
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "异常处理",
      dialogHide: false,
      form: {
        month: new Date(),
        staffId: ''
      },
      dialogHide: false,
      staffList: [],
      dataList: {},
      total: 0,
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      isGetDataFlag: '',
      dialogVisible: false,
      parmar: {
        remark: ''
      },
      isSuperManage:false,
      option2: this.resetOption(),
      description: ''
    };
  },
  created() {
    this.form.month = this.formatMonth(new Date())
    this.init();
  },
  mounted() {},
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        this.companyStaffList();
        this.addEditShow = true;
        let obj = JSON.parse(localStorage.getItem("shopInfo"));
        this.isSuperManage = obj.superManage;
        if (!obj.superManage) {
          this.form.staffId = obj.staffId;
          this.form.staffName = obj.staffName; 
        }
      });
    },
    getDescriptionFunc () {
      this.$api.get(this.$url.attendance.getDescription, {
        staffId: this.form.staffId,
        dateMonth: this.form.month
      }).then(res => {
        if (res) {
          this.description = res;
        }
      }).catch(error => {});
    },
    companyStaffList() {
      this.$api.post(this.$url.companyStaff.listAuthForData, {allFlag: false}).then(res => {
        if (res) this.staffList = res;
      })
    },
    getExceptions () {
      this.$api.get(this.$url.attendance.get, {
        month:  this.form.month,
        staffId: this.form.staffId
      }).then(res => {
        if (res) {
          this.dataList = res;
          this.total = Number(res.abnormalPunchTotal) ;
          this.list1 = [];
          this.list2 = [];
          this.list3 = [];
          this.list4 = [];
          this.isGetDataFlag = "";
        }
      })
      // attendance
    },
    back () {
      this.addEditShow = false;
      this.total = 0;
      this.list1 = [];
      this.list2 = [];
      this.list3 = [];
      this.list4 = [];
      this.isGetDataFlag = "";
      this.form = {
        month: new Date(),
        staffId: ''
      }
      this.parmar = {};
      this.$emit("change", true)
    },
    showItem (type) {
      if (this.isGetDataFlag == 'late' && type == 'late') {
        return this.isGetDataFlag = '';
      } else if (this.isGetDataFlag == 'loss' && type == 'loss') {
        return this.isGetDataFlag = '';
      } else if (this.isGetDataFlag == 'no' && type == 'no') {
        return this.isGetDataFlag = '';
      } else if (this.isGetDataFlag == 'leaveEarly' && type == 'leaveEarly') {
        return this.isGetDataFlag = '';
      } else {
        this.isGetDataFlag = type;
      }
      if (type == 'late' && (this.list1.length > 0 || this.dataList.overtimeTotal == 0)) {
        return
      } else if (type == 'loss' && (this.list2.length > 0 || this.dataList.absenceTotal == 0)) {
        return
      } else if (type == 'no' && (this.list3.length > 0 || this.dataList.noAttendanceTotal == 0)) {
        return
      } else if (type == 'leaveEarly' && (this.list4.length > 0 || this.dataList.leaveEarlyTotal == 0)) {
        return
      }
      this.$api.post(this.$url.attendance.getAbnormalByStaffId,{
        attendanceMonth:  this.form.month,
        workStatus: type,
        staffId: this.form.staffId
      }).then(res => {
        if (res) {
          if (type == 'late') {
            this.list1 = res;
          } else if (type == 'loss') {
            this.list2 = res;
          } else if (type == 'no') {
            this.list3 = res;
          } else if (type == 'leaveEarly') {
            this.list4 = res;
          }
        }
      })
    },
    resetOption() {
      return [
        {
          value: 'normal',
          label: '正常'
        },
        // {
        //   value: 'no',
        //   label: '未打卡'
        // },
        {
          value: 'personalLeave',
          label: '请假'
        },
        {
          value: 'quit',
          label: '离职'
        }
      ]
    },
    submit() {
      this.parmar.attendanceDate = this.formatDay(this.parmar.attendanceDate)
      this.parmar.abnormalType = this.parmar.abnormalAttendanceType;
      this.$api.post(this.$url.attendanceApply.apply, this.parmar)
      .then(res => {
        if (res) {
          this.$message.success("操作成功");
          this.dialogVisible = false;
          this.parmar = {};
        }
      });
    },
    cancel () {
      this.dialogVisible = false;
      this.option2 = this.resetOption()
    },
    goDealWith (row) {
      this.description = ''
      this.dialogVisible = true;
      row.remark = "";
      this.parmar = JSON.parse(JSON.stringify(row));
      if (this.parmar.attendanceType == 'work' && this.parmar.abnormalAttendanceType != 'late') {
        this.option2.unshift({
          value: 'late',
          label: '迟到'
        })
      } else if (this.parmar.attendanceType == 'offWork' && this.parmar.abnormalAttendanceType != 'leaveEarly') {
        this.option2.unshift({
          value: 'leaveEarly',
          label: '早退'
        })
      } else if (this.parmar.attendanceType == 'offWork' && this.parmar.abnormalAttendanceType != 'no') {
        this.option2.unshift({
          value: 'no',
          label: '未打卡'
      })
      }
      this.getDescriptionFunc()
    },
    skip (value) {
      if (value != 'personalLeave' && value != 'quit') return
      if (this.isSuperManage) { // 店长跳列表转申请  店员跳申请
        if (value == 'personalLeave') {
          let parmar = {
            isSuperManage: this.isSuperManage,
            staffId: this.parmar.staffId,
            attendanceDate: this.parmar.attendanceDate
          }
          this.$router.push("/dataList/companyLeave");
          localStorage.setItem("setCurentUrl", 'dataList/companyLeave');
          sessionStorage.setItem("attendanceParmas", JSON.stringify(parmar));
        } else {
          let parmar = {
            isSuperManage: this.isSuperManage,
            id: this.parmar.staffId,
            source: 'superManage'
          }
          this.$router.push("/manage/companyRecode");
          localStorage.setItem("setCurentUrl", 'manage/companyRecode');
          sessionStorage.setItem("attendanceParmas", JSON.stringify(parmar));
        }
      } else {
        if (value == 'personalLeave') {
          let parmar = {
            isSuperManage: this.isSuperManage,
            staffId: this.parmar.staffId,
            attendanceDate: this.parmar.attendanceDate
          }
          this.$router.push("/dataList/companyLeave");
          localStorage.setItem("setCurentUrl", 'dataList/companyLeave');
          sessionStorage.setItem("attendanceParmas", JSON.stringify(parmar));
        } else {
          let parmar = {
            isSuperManage: this.isSuperManage,
            id: this.parmar.staffId,
            staffName: this.parmar.staffName,
            source: 'superManage'
          }
          this.$router.push("/manage/companyRecode");
          localStorage.setItem("setCurentUrl", 'manage/companyRecode');
          sessionStorage.setItem("attendanceParmas", JSON.stringify(parmar));
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.list-box {
  // padding: 10px 0;
  margin-bottom: 24px;
  border: 1px solid #DCDEE0;
  border-radius: 4px;
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
  }
  .attendanceBox {
    border-top: 1px solid #eee;
    padding-top: 10px;
    margin-top: 10px;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 10px;
    }
  }
}
.dialog-remark {
  font-size: 16px;
  margin: 20px 0 10px;
}
.elRow {
  font-size: 16px;
  padding: 20px;
  color: #999;
  background: #FAFAFA;
  border: 1px solid #EEEEEE;
  border-radius: 4px;
  .w100 {
    width: 130px;
  }
}
</style>